// extracted by mini-css-extract-plugin
export default {"groupHeader":"PeopleGroupHeadingContainer-module__groupHeader___ZlCSo"};